





































import { defineComponent, onBeforeUnmount, onMounted } from '@nuxtjs/composition-api';
import { SfModal } from '@storefront-ui/vue';
import debounce from 'lodash.debounce';
import type { PropType } from '@nuxtjs/composition-api';
import { PRODUCT_GALLERY } from '~/constants/productGallery';
import type { Product360Image } from '~/types/product/Product360Image';

export default defineComponent({
  components: { SfModal },
  props: {
    threeSixtyImage: {
      type: [Object, null] as PropType<Product360Image | null>,
      default: null,
    },
  },
  setup(_, { emit }) {
    onMounted(() => {
      setGalleryHeightBasedOnDocumentHeight();
      window.addEventListener('resize', resizeListener);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', resizeListener);
    });

    const setGalleryHeightBasedOnDocumentHeight = () => {
      const heightAndWidth =
        document.documentElement.clientHeight - PRODUCT_GALLERY.GALLERY_360_IMAGE_CONTENT_HEIGHT_OFFSET;

      const v360Container = document.querySelector('.v360-image-container') as HTMLElement;
      v360Container.style.height = `${heightAndWidth}px`;
      v360Container.style.width = `${heightAndWidth}px`;
    };

    const resizeListener = () => {
      debounce(() => {
        setGalleryHeightBasedOnDocumentHeight();
      }, 100)();
    };

    const closeModal = () => emit('close');

    return {
      PRODUCT_GALLERY,
      closeModal,
    };
  },
});

